import React, {useEffect} from "react";
import { useTranslate } from 'react-redux-multilingual'

const RefundOtherPaymentMode = (props) =>{
    const t =useTranslate()

    const handleSubmit = (e) =>{
        if(e) e.preventDefault()
        props.setLoad(true)
        props.refundApi({
            id:props.cookies.current_ticket,
            remboursement_montant:+props.total,
            remboursement_mode:props.mode,
            remboursement_verse:+props.total,
        })
    }

    useEffect(()=>{//le montant et le mode sont déjà connus (bouton choisi dans la grille) : on lance le remboursement sans attendre un second clic
        handleSubmit()
    },[])

    return(
        <form onSubmit={handleSubmit}>
            <div className="row input-group mb-2">
                <div className="col">
                    <label htmlFor="amount">{t('amount')}</label>
                    <input disabled className='form-control' value={props.total} type="text" />
                </div>
            </div>
            <button disabled={props.load} className="btn btn-primary mt-1">
                {props.load ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('add')}
            </button>
        </form>
    )
}

export default RefundOtherPaymentMode;
